// extracted by mini-css-extract-plugin
export var container = "NewsIndex-module--container--cxMev";
export var newsCard = "NewsIndex-module--newsCard--5gLgk";
export var eyeCatchIndexBgFdm = "NewsIndex-module--eyeCatchIndexBgFdm--9BdSn";
export var eyeCatchIndexBgLisa = "NewsIndex-module--eyeCatchIndexBgLisa--uMdlR";
export var eyeCatchImage = "NewsIndex-module--eyeCatchImage--f4fSq";
export var categoryTxt = "NewsIndex-module--categoryTxt--cGJwG";
export var arrowButton = "NewsIndex-module--arrowButton--WvEEE";
export var pageButton = "NewsIndex-module--pageButton--itPuo";